import type { FaireProductEntity } from "../../entity_types/product";

export const p_3xmvbek4: FaireProductEntity = {
  token: "p_3xmvbek4",
  type: "product",
  name: "Speedy Recovery Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/f20d070c48cbb8f83d60d4a2d0274eed2198c259d7d1fa6dc562e7676025792b.png",
  galleryImageUrls: [
    "https://cdn.faire.com/res/hszgttpjt/image/upload/b5f933ddde7b18c3155b78071cb32bdb0c98da927ea032523beb3937d4a119ad/1528358294.png",
    "https://cdn.faire.com/fastly/2e94d549a13ab1c695f49d8ecda3e3d5093891f1b489603de5b05339a65a1e75.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:37:06.629Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
